export default __webpack_public_path__ + "static/media/background.41bf41e2.mp4";